import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import { push } from 'connected-react-router';

import apiAuthCall from 'helpers/apiAuthCall';
import { throttle } from 'helpers/sagaEffects';
import {
    fetchListSuccess,
    actions,
    createCapabilityForm,
    fetchCapabilitySuccess,
    updateCapabilityForm,
} from './duck';
import {
    capabilitiesEndpoint,
    updateCapabilityEndpoint,
    getCapabilityEndpoint
} from './selectors';

export function* createCapability(api, action) {
    const notificationId = 'createCapability';

    try {
        const payload = action.payload;

        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'post',
                url: yield select(capabilitiesEndpoint),
                data: payload
            }
        );

        yield put(createCapabilityForm.success());
        yield put(notify({
            id: notificationId,
            message: `${action.payload.name || 'Capability'} created!`,
            status: result.status
        }));
        yield put(push('/admin/capabilities'));
    } catch (err) {
        yield put(createCapabilityForm.failure(err));
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export function* fetchCapabilityList(api, action) {
    const notificationId = 'getCapabilityList';

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(capabilitiesEndpoint)
            }
        );

        yield put(fetchListSuccess(result.data));
    } catch (err) {
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export function* fetchCapability(api, action) {
    const notificationId = action.type;

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(getCapabilityEndpoint, action.payload)
            }
        );

        yield put(fetchCapabilitySuccess(result.data));
    } catch (err) {
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export function* updateCapability(api, action) {
    const notificationId = 'updateCapability';

    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'put',
                url: yield select(updateCapabilityEndpoint, { capabilityId: action.payload.id }),
                data: action.payload
            }
        );

        yield put(updateCapabilityForm.success());
        yield put(notify({
            id: notificationId,
            message: `${action.payload.name || 'Capability'} updated!`,
            status: result.status
        }));
        yield put(push('/admin/capabilities'));
    } catch (err) {
        yield put(updateCapabilityForm.failure(err));
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}


export default function* capabilitySaga({ api }) {
    yield all([
        takeLatest(createCapabilityForm.REQUEST, createCapability, api),
        takeLatest(updateCapabilityForm.REQUEST, updateCapability, api),
        throttle(200, actions.FETCH_CAPABILITY_LIST, fetchCapabilityList, api),
        takeLatest(actions.FETCH_CAPABILITY, fetchCapability, api),
    ]);
}



// WEBPACK FOOTER //
// ./src/services/capabilities/saga.js